<template>
  <div class="Child">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="funcFilter">
          查询
        </el-button>
        <el-button type="primary" @click="getRadioEvent">
          获取选中
        </el-button>
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      height="600"
      :radio-config="{ highlight: true }"
      :data="tableData"
      align="center"
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      :loading="loading"
      sort-config.remote
      @sort-change="sortList"
    >
      <vxe-table-column type="radio" width="60" />
      <!-- <vxe-table-column>
        <vxe-table-column field="branchCode" title="机构" :formatter="formatterBranch" min-width="100" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.branchCode" placeholder="请选择" clearable>
            <el-option v-for="(item,index) in branchList" :key="'branchList'+index" :label="item.groupName" :value="item.code" />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="roleName"
          title="角色名称"
          min-width="80"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roleName"
            placeholder="请输入角色名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="角色类型"
          min-width="100"
          :formatter="formatterType"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" clearable placeholder="请选择">
            <el-option
              v-for="(item, index) in typeList"
              :key="'typeList' + item.value + index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="description"
          title="备注"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.description"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      loading: false,
      tableData: [],
      listQuery: {
        shipmentCode: "",
        branchCode: "",
        role: "",
        roleName: "",
        type: "",
        description: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      formData: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      // 类型
      typeList: [
        { label: "托运人添加", value: 0 },
        { label: "内置角色", value: 1 },
        { label: "内置托运人员工角色", value: 2 }
      ]
    };
  },
  // computed:{
  //   branchList() {
  //     return this.$store.state.components.branchList
  //   }
  // },
  // watch:{
  //   '$store.state.components.branchList':function(){
  //     this.$refs.xTable.updateData()
  //   }
  // },
  created() {},
  methods: {
    findList(item) {
      if (item) {
        this.listQuery = {
          shipmentCode: "",
          branchCode: "",
          role: "",
          roleName: "",
          type: "",
          description: "",
          pageNum: 1,
          pageSize: 20,
          sortField: "",
          sortType: "",
          total: 0
        };
        this.listQuery.branchCode = item.branchCode;
      }
      return new Promise(resolve => {
        this.loading = true;
        this.listQuery.shipmentCode = this.$route.query.partyCode || "";
        request({
          url: "/ntocc-basic-api/role",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 翻译类型
    formatterType({ cellValue }) {
      const item = this.typeList.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 获取选中
    getRadioEvent() {
      this.selectRecords = this.$refs.xTable.getRadioRecord();
      this.$emit("event", this.selectRecords);
    }
  }
};
</script>

<style lang="scss" scoped></style>
